import { useMutation, useQueryClient } from "@tanstack/react-query";
import { removePendingAdvisorAndInvalidate } from "web_myplann/Api/Advisor/removePendingAdvisorAndInvalidate";
import {
	type PatchAgentIdConnectionRefuseV2FetchResponse,
	patchAgentIdConnectionRefuseV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useAdvisorRefuseConnectionMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse<
			number,
			PatchAgentIdConnectionRefuseV2FetchResponse
		>((advisorId) => patchAgentIdConnectionRefuseV2(advisorId)),
		onSuccess: (_response, advisorId) =>
			removePendingAdvisorAndInvalidate(queryClient, advisorId),
	});
};
